import React from "react";

const SingleSelect = (props) => {
    return (
        <div className="w-full">
            <div className="relative mt-2">
                <div className="TagDropDown">
                    <ul className="w-full">
                        {props?.list?.map((item) => (
                            <div className={"p-2 flex  flex-col gap-1"} key={item._id}>
                                <button
                                    className={"flex items-center justify-between"}
                                    onClick={() => props.selectItem(item)}
                                >
                                    <li key={item._id} className="flex items-center p-1 ">
                                        {item.name}
                                    </li>
                                    {!props.noIcon && (
                                        <img
                                            alt={"Logo"}
                                            src={"/media/icons/tag.svg"}
                                            className={"h-[18px] w-[18px]"}
                                        />
                                    )}
                                </button>
                                <div className={"HorizontalDivider"}></div>
                            </div>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default SingleSelect;
